import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const MaengelMelder = () => import('@/views/MaengelMelder')
const MangelLocation = () => import('@/views/MangelLocation')
const MangelControl = () => import('@/views/MangelControl')
const Unsubscribe = () => import('@/views/Unsubscribe')
const Test = () => import('@/views/Test')

Vue.use(Router);

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/maengel/:id',
      name: 'Maengelmelder',
      component: DefaultContainer,
      children: [
        {
          path: 'maengel',
          redirect: '/maengel/:id',
          name: 'Maengelmelder',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ":id",
              name: 'Maengelmelder',
              component: MaengelMelder
            },
          ],
        },
        {
          path: 'location',
          redirect: '/location/show',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "show",
              component: MangelLocation
            },
          ],
        },
        {
          path: 'control',
          redirect: '/control/:id',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ":id",
              component: MangelControl
            },
          ],
        },
        {
          path: 'unsubscribe',
          redirect: '/unsubscribe/:id',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ":id",
              component: Unsubscribe
            },
          ],
        },
      ]
    },
  ]
})


/*

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/:id/maengel',
      name: 'Maengelmelder',
      component: DefaultContainer,
      children: [
        {
          path: ':id',
          redirect: '/:id/maengel',
          name: 'Maengelmelder',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "maengel",
              name: 'Maengelmelder',
              component: MaengelMelder
            },
          ],
        },
      ]
    },
  ]
})


 */
